export enum SpecRole {
  DPS = 'dps',
  Healer = 'healer',
  Tank = 'tank'
}

export enum ExtendedSpecRole {
  MeleeDps = 'melee-dps',
  RangedDps = 'ranged-dps',
  Healer = 'healer',
  Tank = 'tank'
}
